function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask4",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 60,
  height: 60
}, React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 15,
  stroke: "black",
  strokeWidth: 30
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask4)"
}, React.createElement("g", {
  opacity: 0.636
}, React.createElement("path", {
  d: "M22.938 54.667C9.92 54.667 6 36.696 6 23.678C6 10.66 23.287 6 36.305 6C49.323 6 54.825 16.482 54.825 29.5C54.825 42.518 35.955 54.667 22.938 54.667Z",
  stroke: "#00C1F1"
}), React.createElement("path", {
  d: "M33.938 54C46.956 54 52.825 39.221 52.825 26.204C52.825 13.186 33.955 6 20.938 6C7.92 6 6.525 19.078 6.525 32.096C6.525 45.114 20.92 54 33.938 54Z",
  stroke: "#00C1F1"
})));

var Svg5 = function Svg5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/5.ea905cdb.svg";
export { ForwardRef as ReactComponent };